function menuTabClick() {
    // document.addEventListener('DOMContentLoaded', function () {
        const tabs = document.querySelectorAll('.sub-menu li');
        const tabMenu = document.querySelectorAll('.nav-tabs .nav-link');
        const tabContent = document.querySelectorAll('.tab-pane');
    
        var headerHeight = document.querySelector('.navbar').offsetHeight;
    
        function showTabContent(tabId) {
            tabContent.forEach(tab => {
                if (tab.id === tabId) {
                    tab.classList.add('show', 'active');
                } else {
                    tab.classList.remove('show', 'active');
                }
            });
    
            tabMenu.forEach(tab => {
                if (tab.getAttribute('href') === `#${tabId}`) {
                    tab.classList.add('active');
                } else {
                    tab.classList.remove('active');
                }
            });
    
            // const targetTab = document.getElementById(tabId);
            // if (targetTab) {
            //     var tabOffsetTop = targetTab.offsetTop - ( headerHeight + 100 );
            //     window.scrollTo({
            //         top: tabOffsetTop,
            //         behavior: 'smooth'
            //     });
            // }
        }
    
        function handleTabClick(event, targetTabId) {
            event.preventDefault();
            showTabContent(targetTabId);
        }
    
        tabs.forEach(tab => {
            tab.addEventListener('click', event => {
                const targetTabId = tab.getAttribute('href').substr(1);
                handleTabClick(event, targetTabId);

            });
        });
    
        function getHashFromLocation() {
            const hash = window.location.hash;
            return hash ? hash.slice(1) : 'pane-1';
        }
    
        const initialTabId = getHashFromLocation();
        showTabContent(initialTabId);
        
        // Handle hash changes in URL
        window.addEventListener('hashchange', () => {
            const newTabId = getHashFromLocation();
            showTabContent(newTabId);
        });
    // });
}
menuTabClick();

document.addEventListener('DOMContentLoaded', function() {
    menuTabClick();
}, false);


function activeTabPane() {
      document.querySelectorAll('.sub-menu li a').forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault(); // Prevent default link behavior
    
          // Remove the 'highlight' class from all tab panes
          document.querySelectorAll('.tab-pane').forEach(function (pane) {
            pane.classList.remove('active');
          });
    
          var href = this.getAttribute('href'); // Get the href attribute
          var tabPane = document.querySelector(href); // Find the corresponding tab pane
          var tab = new bootstrap.Tab(tabPane); // Create a new Tab instance
          tab.show(); // Show the tab
    
          // Add the 'highlight' class to the activated tab pane
          tabPane.classList.add('active');
        });
      });
}

// activeTabPane();
